import React from 'react';
import ActivityLogs from '../../components/admin/ActivityLogs';

/**
 * AdminActivityPage - Activity logs page for administrators
 * Accessible at /admin/activity
 * Provides activity log viewing and filtering capabilities
 */
const AdminActivityPage: React.FC = () => {
  return <ActivityLogs />;
};

export default AdminActivityPage; 